import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {RecordService} from "../../record/services/record.service";
import {ApiFragment} from "../../record/entities/api-fragment.entity";


@Injectable()
export class ScanSandbox {
    constructor(private recordService: RecordService) {
    }

    getRecordById(id: string): Observable<ApiFragment> {
        return this.recordService.getByRecordId(id);
    }
}
